import React, { useEffect, useState } from 'react'
// import DesktopHeader from 'AccountsDesktopComponents/DesktopHeader'
import TagManager from 'react-gtm-module'
import DesktopHeader from 'AccountsDesktopComponents/Header'

import DesktopFooter from 'AccountsDesktopComponents/Footer'
import { withRouter } from 'react-router-dom'
import { AccountsState } from 'AccountsContext'
import { getCookie, delete_cookie, getGtmId } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'
import RouterDesktop from './RouterDesktop'
import {
  initializeClevertap,
  redirectMobileView,
  triggerClevertap
} from './utils'
// import '@cleartrip/bento/dist/index.css'
// import '@cleartrip/bento/bento.css'
// import './styles/index.css'
import './styles/index.css'
import { getUserProfileDetails } from './pages/Trips/trips.helper'
import {
  responseMapper,
  sendProfileData,
  updateProfileData
} from './utils/clevertapProfile'

import './AppDesktop.css'
import { deviceId } from './deviceIdUtils'
import { checkMobileDevice } from './utils/validator'
import Header from './components/Desktop/Header'

const AppDesktop = () => {
  useEffect(() => {
    const gtmId = getGtmId()
    if (gtmId) TagManager.initialize({ gtmId })
    deviceId()
    const isMobileDevice = checkMobileDevice()
    if (!isMobileDevice) {
      if (getCookie('selectedLanguage') == 'ar') {
        document.documentElement.setAttribute('dir', 'rtl')
      } else {
        document.documentElement.setAttribute('dir', 'ltr')
      }
      if (getCookie('ct-pwa')) {
        delete_cookie('ct-pwa')
      }
    }
  }, [])
  window.androidData = window?.MobileApp ?
    JSON.parse(window?.MobileApp?.getAppSpecificData()) :
    {}
  return (
    <AccountsState>
      <AccountsView />
    </AccountsState>
  )
}

const AccountsView = withRouter(({ match }) => {
  const [containerLoaded, containerLoadingHandler] = useState(false)

  useEffect(() => {
    redirectMobileView()
  })
  useEffect(() => {
    if (window && window.location.pathname.indexOf('?src=home') > -1) {
      window.location.href = window.location.pathname.replace('?src=home', '')
    }
    setTimeout(() => {
      containerLoadingHandler(true)
    }, 500)
  })
  useEffect(() => {
    initializeClevertap()
    const getUserDetails = async type => {
      const response = await getUserProfileDetails()
      const { status, data } = response || {}
      if (status === 200) {
        const finalPayload = responseMapper(data)
        if (type === 'login') {
          sendProfileData(finalPayload)
        } else {
          updateProfileData(finalPayload)
        }
      }
    }
    document.addEventListener('CLEVERTAP_PROFILE', ({ detail }) => {
      const { type } = detail
      getUserDetails(type)
    })
  }, [])

  useEffect(() => {
    triggerClevertap('PWA Loaded')
  }, [])
  let pageView
  if (containerLoaded) {
    pageView = (
      <React.Fragment>
        {isInFlyinDomain() ? <Header /> : <DesktopHeader />}
        <RouterDesktop match={match} />
        <DesktopFooter />
      </React.Fragment>
    )
  }
  return <main>{pageView}</main>
})

export default AppDesktop

// <section className="whiteBg">
//   <section className="flex container">
//     <div className="w-100p">
//       {/* eslint-disable-next-line react/no-unescaped-entities */}
//       <h1 className={mapClass}>{message}</h1>
//     </div>
//   </section>
//   <section className="flex container">
//     <aside className="w-20p">
//       <LHSNavigation />
//     </aside>
//   </section>
// </section>
